import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	graphButtonLabelNonFinal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	graphButtonLabelNonFinal: {
		id: 'graph.graph-button-label-non-final',
		defaultMessage: 'Open the graph',
		description: 'Explains to the user what will happen when they click on the graph button',
	},
});
export default messages;
